export default __webpack_public_path__ + "44ea008ea5230870f4949c4cb514c2d0.png";